/* tslint:disable */
/* eslint-disable */
/**
 * Y-Sports backend-next Management API
 * Composed management-facing contract for `backend-next`. This spec is an aggregation layer over module-scoped contracts and should reference canonical module definitions instead of copying them. 
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { TrainingNoteVisibility } from './TrainingNoteVisibility';
import {
    TrainingNoteVisibilityFromJSON,
    TrainingNoteVisibilityFromJSONTyped,
    TrainingNoteVisibilityToJSON,
    TrainingNoteVisibilityToJSONTyped,
} from './TrainingNoteVisibility';
import type { TrainingNoteType } from './TrainingNoteType';
import {
    TrainingNoteTypeFromJSON,
    TrainingNoteTypeFromJSONTyped,
    TrainingNoteTypeToJSON,
    TrainingNoteTypeToJSONTyped,
} from './TrainingNoteType';

/**
 * 
 * @export
 * @interface TrainingNoteCreateRequest
 */
export interface TrainingNoteCreateRequest {
    /**
     * 
     * @type {string}
     * @memberof TrainingNoteCreateRequest
     */
    sessionId?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TrainingNoteCreateRequest
     */
    playerId?: string | null;
    /**
     * 
     * @type {TrainingNoteVisibility}
     * @memberof TrainingNoteCreateRequest
     */
    visibility: TrainingNoteVisibility;
    /**
     * 
     * @type {TrainingNoteType}
     * @memberof TrainingNoteCreateRequest
     */
    noteType: TrainingNoteType;
    /**
     * 
     * @type {string}
     * @memberof TrainingNoteCreateRequest
     */
    title?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TrainingNoteCreateRequest
     */
    body: string;
    /**
     * 
     * @type {string}
     * @memberof TrainingNoteCreateRequest
     */
    relatedMatchId?: string | null;
    /**
     * 
     * @type {Date}
     * @memberof TrainingNoteCreateRequest
     */
    eventDate?: Date | null;
}



/**
 * Check if a given object implements the TrainingNoteCreateRequest interface.
 */
export function instanceOfTrainingNoteCreateRequest(value: object): value is TrainingNoteCreateRequest {
    if (!('visibility' in value) || value['visibility'] === undefined) return false;
    if (!('noteType' in value) || value['noteType'] === undefined) return false;
    if (!('body' in value) || value['body'] === undefined) return false;
    return true;
}

export function TrainingNoteCreateRequestFromJSON(json: any): TrainingNoteCreateRequest {
    return TrainingNoteCreateRequestFromJSONTyped(json, false);
}

export function TrainingNoteCreateRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): TrainingNoteCreateRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'sessionId': json['sessionId'] == null ? undefined : json['sessionId'],
        'playerId': json['playerId'] == null ? undefined : json['playerId'],
        'visibility': TrainingNoteVisibilityFromJSON(json['visibility']),
        'noteType': TrainingNoteTypeFromJSON(json['noteType']),
        'title': json['title'] == null ? undefined : json['title'],
        'body': json['body'],
        'relatedMatchId': json['relatedMatchId'] == null ? undefined : json['relatedMatchId'],
        'eventDate': json['eventDate'] == null ? undefined : (new Date(json['eventDate'])),
    };
}

export function TrainingNoteCreateRequestToJSON(json: any): TrainingNoteCreateRequest {
    return TrainingNoteCreateRequestToJSONTyped(json, false);
}

export function TrainingNoteCreateRequestToJSONTyped(value?: TrainingNoteCreateRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'sessionId': value['sessionId'],
        'playerId': value['playerId'],
        'visibility': TrainingNoteVisibilityToJSON(value['visibility']),
        'noteType': TrainingNoteTypeToJSON(value['noteType']),
        'title': value['title'],
        'body': value['body'],
        'relatedMatchId': value['relatedMatchId'],
        'eventDate': value['eventDate'] == null ? value['eventDate'] : value['eventDate'].toISOString().substring(0,10),
    };
}

